import { CogIcon, FuelIcon, ShieldCheckIcon, ThermometerIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Diesel Engine Fundamentals: The Four-Stroke Cycle, Combustion & Core Engine Components',
    summary: 'A visual technical reference to how a diesel engine works, the four-stroke cycle, diesel combustion, displacement and compression ratio, the core engine components and power, torque and speed.',
    icon: CogIcon,
  },
  {
    number: '02',
    title: 'Diesel Fuel Systems: Fuel Quality, Storage, Filtration, Injection Pumps, Injectors & Common Rail',
    summary: 'A visual technical reference to diesel fuel properties and contamination, fuel storage, the low-pressure circuit and filtration, injection pumps, injectors, common rail and high-pressure fuel safety.',
    icon: FuelIcon,
  },
  {
    number: '03',
    title: 'Engine Support Systems: Lubrication, Cooling, Air Intake, Exhaust & Turbocharging',
    summary: 'A visual technical reference to engine oil and the lubrication circuit, coolant and the cooling system, air filtration, the turbocharger and charge-air cooling, and the exhaust system.',
    icon: ThermometerIcon,
  },
  {
    number: '04',
    title: 'Diesel Generator Sets: Alternators, Voltage & Speed Regulation, Paralleling & Automatic Transfer',
    summary: 'A visual technical reference to genset anatomy and ratings, kW, kVA and power factor, the alternator and AVR, speed governing, protections, automatic transfer switches and paralleling.',
    icon: ZapIcon,
  },
  {
    number: '05',
    title: 'Diesel Engine & Genset Maintenance and Diagnostics: Preventive Maintenance, Condition Monitoring & Typical Failures',
    summary: 'A visual technical reference to maintenance strategies and checks, service tasks, oil and coolant analysis, smoke and noise diagnosis, troubleshooting trees and typical failures.',
    icon: WrenchIcon,
  },
  {
    number: '06',
    title: 'Safe Operation, Load Testing & Generator Fleet Management',
    summary: 'A visual technical reference to genset site safety, starting, running and stopping, automatic standby, load-bank testing, fuel management and generator fleet management.',
    icon: ShieldCheckIcon,
  },
];
